const baseActions = {
  init({ commit }) {
    commit('initTimer', 0);
  },
  initAuctions({ state, commit }, { auctions = [] }) {
    state.auctions = [];

    auctions.forEach((auction) => {
      commit('addAuction', auction);
    });

    commit('sortAuctions');
  },
};

export default baseActions;



// WEBPACK FOOTER //
// ./src/store/actions/index.js